import type { SVGProps } from 'react';

/** Figma `fatigue-bad.svg` — `tools/make-icon-components.py`가 만든다. 손으로 고치지 않는다. */
export const FatigueBadIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 22 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="Frame" clipPath="url(#clip0_1320_2633)">
      <path
        id="Vector"
        d="M2 14L6 6L9 11L12 2L15 11L18 6L22 14"
        stroke="#6B59D9"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1320_2633">
        <rect width="22" height="20" fill="currentColor" />
      </clipPath>
    </defs>
  </svg>
);
